import React from 'react';
import { Button } from 'semantic-ui-react';
import { func, bool, string } from 'prop-types';
import classnames from 'classnames';
import FileUpload from 'Modules/FileUpload/FileUpload';
import IconAttachment from 'Assets/icons/icon-attach-media.svg';
import { DEFAULT_DOCUMENT_FILE_TYPES_UPLOAD } from 'Constants/commons';
import { Flex } from 'antd';

import styles from './TextComposer.less';

const AttachmentButton = props => {
  const { disabled, uploadImage, isMinimize, buttonTex } = props;
  const onChange = async files => {
    const file = files[0];
    try {
      if (file) {
        await uploadImage(file);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const classNames = classnames([styles.buttonIcon], { [styles.miniIcon]: isMinimize });
  return (
    <FileUpload onChange={onChange} accept={DEFAULT_DOCUMENT_FILE_TYPES_UPLOAD}>
      <Button basic icon disabled={disabled} className={classNames}>
        <Flex align="center" gap={8}>
          <img alt="attachment" src={IconAttachment} />
          {buttonTex}
        </Flex>
      </Button>
    </FileUpload>
  );
};

AttachmentButton.propTypes = {
  disabled: bool,
  uploadImage: func,
  isMinimize: bool,
  buttonTex: string,
};

AttachmentButton.defaultProps = {
  disabled: false,
  isMinimize: false,
  uploadImage: () => true,
  buttonTex: '',
};

export default AttachmentButton;
